import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 9563FB80-4D77-4800-B7DF-CCFDD00A49DD
 * name alpha-o-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-o-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaOBoxOutlineIcon = createSvgIcon(<><path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5M11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,9V15H13V9H11Z" /></>, 'AlphaOBoxOutlineIcon');
export default AlphaOBoxOutlineIcon